module.exports = __webpack_public_path__ + "img/eyouth.a0e9a29f.svg";